module.exports = {"api":{"host":"https://api.virtask.nl","routes":{"token":"/auth/token"}},"LOCALE":"en"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 392
// module chunks = 9